import React from 'react';
import Card from '../../../organisms/card/Card';
import { ENDPOINTS, CONSTS } from '../../utils/endpoints';
import { useSelector } from 'react-redux';
import { getCompany } from '../../../../redux/companySlice';

const LMGrid = ({ data }) => {
  const company = useSelector((state) => getCompany(state));

  const getBaseUrl = (item) => {
    switch (item.material_type.toLowerCase()) {
      case CONSTS.WALKTHROUGH:
        return ENDPOINTS.VIEW_WALKTHROUGH(company.slug, item.slug);
      case CONSTS.VIDEO:
        return ENDPOINTS.VIEW_WALKTHROUGH(company.slug, item.slug);
      case CONSTS.PATHS:
        return ENDPOINTS.VIEW_PATH(company.slug, item.slug);
      default:
        break;
    }
  }

  const renderRows = () => {
    let rows = [];
    let row = [];
    data.map((item, index) => {
      const baseUrl = getBaseUrl(item);
      row.push(
        <Card
          key={index}
          item={item}
          baseUrl={baseUrl}
          companySlug={company.slug}
        />
      );
      if ((index + 1) % 4 === 0) {
        rows.push(row);
        row = [];
      }
    });
    if (row.length > 0) {
      rows.push(row);
    }
    return rows;
  }

  return (
    <div>
      <div className="un-grid-container">{renderRows()}</div>
    </div>
  );
};

export default LMGrid;
